module.exports = __webpack_public_path__ + "img/trophy1.png";